<template>
  <div class="postDetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    

    <div class="card" v-if="active == 0">
      <ul>
        <li v-for="(item,i) in arr" @click="toPush(item.id,'specialPay')">
          <h3>{{item.title}}</h3>
          <div class="price"><font>使用时间：</font>{{item.starttime}} 至 {{item.endtime}}</div>
          <div class="rate"><font>市场价：</font><span style="text-decoration: line-through">￥{{item.price}}</span></div>
          <div class="price"><font>优惠价：</font>
            <i>￥</i><b>{{item.rate.split(".")[0]}}</b>
            <i>.{{item.rate.split(".")[1]}}</i>
          </div>
          <a>立即购买</a>
        </li>
        
      </ul>
      <div class="none"  v-if="arr.length <= 0 ">
        <div style="height:80px"></div>
        <img src="~assets/images/no.png" style="display:block;width:100%">
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        setDetail:[],
        active:0,
        arr:[],
        positionFlag:false,
        code:''
      };
    },
    created(){
      //this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/specialCard');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      this.getDetail()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      toggle(index){
        this.active=index;
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/Special/detail',
          params:{
            id:id,
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data;
          that.setDetail = res.data.rs;
          that.arr = res.data.arr;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .postDetailApp{
    background:#f7faff;
  }


  .postDetailApp .card{
    width:100%;
    display:block;
    min-height:400px;
    padding-bottom:10px;
    padding-top:10px
  }
  .postDetailApp .card ul{
    width:92%;
    display:block;
    margin:0 auto;
  }
  .postDetailApp .card ul li{
    background:#fff;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius:8px;
    width:100%;
    margin-bottom:15px;
    border-radius:8px;
    position:relative;
  }
  .postDetailApp .card ul li h3{
    font-size:16px;
    padding:15px 15px 10px 15px;
    width:75%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1px;
    color:#333
  }

  .postDetailApp .card ul li .price{
    font-size:15px;
    padding:0 15px 10px 15px;
    color:#999
  }
  .postDetailApp .card ul li .rate{
    font-size:15px;
    padding:0 15px 10px 15px;
    color:#999
  }
  .postDetailApp .card ul li .price font{
    color:#999;
    font-size:15px;
  }
  .postDetailApp .card ul li .price b{
    color: #FF6600;
    font-size:17px;
    font-weight:500;
  }

  .postDetailApp .card ul li .price i{
    color: #FF6600;
    font-size:12px;
    font-style:normal
  }
  .postDetailApp .card ul li a{
    position:absolute;
    right:20px;
    top:70%;
    transform: translateY(-50%);
    color:#2F78FF;
    border: 1px solid #2F78FF;
    border-radius: 30px;
    width: 83px;
    height: 30px;
    text-align:center;
    line-height:30px;
    font-weight: 600;
    font-size:14px;
  }
  
</style>